import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['acceptance', 'submit']

  connect() {
    this.refresh()
  }

  refresh() {
    this.submitTarget.disabled = !this.acceptanceTarget.checked
  }
}
